import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ModelNotification\MarkAsReadModelNotificationController::__invoke
* @see app/Http/Controllers/ModelNotification/MarkAsReadModelNotificationController.php
* @route '/api/mark-as-read'
*/
const MarkAsReadModelNotificationController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: MarkAsReadModelNotificationController.url(options),
    method: 'post',
})

MarkAsReadModelNotificationController.definition = {
    methods: ["post"],
    url: '/api/mark-as-read',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\ModelNotification\MarkAsReadModelNotificationController::__invoke
* @see app/Http/Controllers/ModelNotification/MarkAsReadModelNotificationController.php
* @route '/api/mark-as-read'
*/
MarkAsReadModelNotificationController.url = (options?: RouteQueryOptions) => {
    return MarkAsReadModelNotificationController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ModelNotification\MarkAsReadModelNotificationController::__invoke
* @see app/Http/Controllers/ModelNotification/MarkAsReadModelNotificationController.php
* @route '/api/mark-as-read'
*/
MarkAsReadModelNotificationController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: MarkAsReadModelNotificationController.url(options),
    method: 'post',
})

export default MarkAsReadModelNotificationController